<div class="container-first-palm">

  <div class="palm1-zoom">
    <img src="assets/{{client}}/palm/1.svg" class="palm1-move" />
  </div>

  <div class="palm2-zoom">
    <img src="assets/{{client}}/palm/2.svg" class="palm2-move" />
  </div>

  <div class="palm3-zoom">
    <img src="assets/{{client}}/palm/3.svg" class="palm3-move" />
  </div>
</div>


<div class="container-reverse-palm">

  <div class="palm1-zoom">
    <img src="assets/{{client}}/palm/1.svg" class="palm1-move" />
  </div>

  <div class="palm2-zoom">
    <img src="assets/{{client}}/palm/2.svg" class="palm2-move" />
  </div>

  <div class="palm3-zoom">
    <img src="assets/{{client}}/palm/3.svg" class="palm3-move" />
  </div>


</div>
